/* eslint-disable react/forbid-component-props, react-hooks/exhaustive-deps, sonarjs/cognitive-complexity */
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import {
  BUTTON_BUY_WITH_VIP,
  BUTTON_PLACE_ORDER,
  VIP_RADIO_HEADING,
} from '../../../config/text/text';
import { formatPrice } from '../../../helpers/currency';
import ThemeContext from '../../../providers/ThemeProvider';
import { logToSplunk } from '../../_generic/axiosSplunk/axiosSplunk';
import VipMessage from './VipMessage';
import VipMessageWrapper from './VipMessageWrapper';

const VipToggleButtons = ({
  currencySymbol,
  finalOrderAmount,
  isExclusiveProductInBasket,
  setPayButton,
  vipOptInFinalOrderAmount,
  vipSubscriptionMessage,
}) => {
  const theme = useContext(ThemeContext);
  const [vipOptIn, setVipOptIn] = useState(null);

  const toggleVipOn = () => {
    setVipOptIn(true);
    logToSplunk(
      {
        component: 'vipToggleButtons',
        type: 'Vip status',
        vipOptIn: true,
      },
      'frontend logs',
    );
    if (setPayButton && typeof setPayButton === 'function') setPayButton(true);
  };

  const toggleVipOff = () => {
    if (isExclusiveProductInBasket) return;
    setVipOptIn(false);
    logToSplunk(
      {
        component: 'vipToggleButtons',
        type: 'Vip status',
        vipOptIn: false,
      },
      'frontend logs',
    );
    if (setPayButton && typeof setPayButton === 'function') setPayButton(false);
  };

  useEffect(() => {
    // reset toggle
    setVipOptIn(null);
    setPayButton(null);
  }, [finalOrderAmount]);

  return (
    <>
      <VipMessageWrapper isRadioHeading>{VIP_RADIO_HEADING}</VipMessageWrapper>
      <div className="col-12">
        <div className="vip-radio-buttons">
          <label className="radio-button-label" id="vip-pay-toggle-on">
            <input
              checked={vipOptIn === true}
              className="radio-button"
              id="vip-pay-toggle-on"
              name="vipPayToggle"
              onChange={() => {}}
              onClick={toggleVipOn}
              type="radio"
              value="true"
            />
            <FontAwesomeIcon
              icon={faLock}
              style={{ height: 22, marginRight: '10px', width: 22 }}
            />
            {BUTTON_BUY_WITH_VIP}{' '}
            <span className="vip-price">
              {currencySymbol}
              {formatPrice(vipOptInFinalOrderAmount, true, true, false)}
            </span>
          </label>
          {vipSubscriptionMessage}
          {!isExclusiveProductInBasket && (
            <label
              aria-disabled={isExclusiveProductInBasket}
              className="radio-button-label radio-button-label__non-vip"
              id="vip-pay-toggle-off"
            >
              <input
                aria-describedby={
                  isExclusiveProductInBasket ? 'disabledReason' : ''
                }
                aria-disabled={isExclusiveProductInBasket}
                checked={vipOptIn === false}
                className="radio-button"
                id="vip-pay-toggle-off"
                name="vipPayToggle"
                onChange={() => {}}
                onClick={toggleVipOff}
                type="radio"
                value="false"
              />
              <FontAwesomeIcon
                icon={faLock}
                style={{ height: 22, marginRight: '10px', width: 22 }}
              />
              {BUTTON_PLACE_ORDER[process.env.NEXT_PUBLIC_SITE || 'wowcher']}{' '}
              <span className="non-vip-price">
                {currencySymbol}
                {formatPrice(finalOrderAmount, true, true, false)}
              </span>
            </label>
          )}
          <VipMessage />
        </div>
      </div>
      <style jsx>{`
        .radio-button-label {
          border-bottom: 1px solid ${theme.commoncolors.greypastel};
          color: ${theme.commoncolors.linkmidblue};
          cursor: pointer;
          display: block;
          font-size: 26px;
          font-weight: bold;
          line-height: 60px;
          margin-bottom: 0;
          text-transform: uppercase;
          width: 100%;
        }
        .voucher-contract-disclamer {
          font-size: 11px;
          margin: 5px;
          text-align: justify;
        }
        @media only screen and (max-width: ${theme.breakpoints.smUp}) {
          .radio-button-label {
            border-bottom: 1px solid ${theme.commoncolors.greypastel};
            color: ${theme.commoncolors.linkmidblue};
            display: block;
            font-size: 15px;
            font-weight: bold;
            line-height: 50px;
            margin-bottom: 0;
            text-transform: uppercase;
            width: 100%;
          }
        }
        .radio-button-label:focus {
          outline: none;
        }
        .radio-button-label:focus-within {
          text-decoration: underline;
        }
        .radio-button-label__non-vip {
          color: ${theme.commoncolors.buttonpaylight};
        }
        .radio-button-label[aria-disabled='true'] {
          cursor: not-allowed;
        }
        .radio-button {
          cursor: pointer;
          margin-right: 20px;
        }
        .non-vip-price {
          margin-left: 20px;
        }
        .disabled-tooltip {
          display: none;
        }
        .radio-button:focus ~ .disabled-tooltip,
        .radio-button:hover ~ .disabled-tooltip,
        .radio-button:active ~ .disabled-tooltip {
          background-color: black;
          border-radius: 6px;
          bottom: 20px;
          color: white;
          display: block;
          font-size: 11px;
          line-height: 11px;
          padding: 10px;
          position: absolute;
          text-transform: none;
        }
        .vip-price {
          margin-left: 20px;
        }
        .vip-radio-buttons {
          margin-bottom: 10px;
        }
      `}</style>
    </>
  );
};

VipToggleButtons.propTypes = {
  currencySymbol: PropTypes.string,
  finalOrderAmount: PropTypes.number,
  isExclusiveProductInBasket: PropTypes.bool,
  setPayButton: PropTypes.func,
  vipOptInFinalOrderAmount: PropTypes.number,
  vipSubscriptionMessage: PropTypes.element,
};

export default VipToggleButtons;
